export interface CommentItem {
  id: number;
  platform: string;
  platformIcon: string;
  user: string;
  time: string;
  text: string;
  likes: string;
  replies: number;
  sentiment: "positive" | "neutral" | "negative";
}

export const commentFeed: CommentItem[] = [
  {
    id: 1,
    platform: "微博",
    platformIcon: "ri-weibo-line",
    user: "吃瓜的圆圆",
    time: "2小时前",
    text: "说实话我一开始也觉得是营销，但看到她直播里那个真性情，又觉得她其实是有点耿直的。至少没塌成那种又当又立，暂时路转黑观望中。",
    likes: "2.3万",
    replies: 412,
    sentiment: "neutral",
  },
  {
    id: 2,
    platform: "抖音",
    platformIcon: "ri-voiceprint-line",
    user: "老王不熬夜",
    time: "5小时前",
    text: "她那个翻白眼合集能笑死我，本来只想看个热闹，结果把几十条全刷完了。不管怎样，情绪价值这块是给满了。",
    likes: "4.1万",
    replies: 687,
    sentiment: "positive",
  },
  {
    id: 3,
    platform: "小红书",
    platformIcon: "ri-pen-nib-line",
    user: "爱丽丝不熬夜",
    time: "8小时前",
    text: "我不是黑粉，纯粹路人。客观讲，人前一套人后一套才是重点，好几条旧帖被打脸，粉丝还硬洗，观感真的有点差。",
    likes: "1.9万",
    replies: 336,
    sentiment: "negative",
  },
  {
    id: 4,
    platform: "贴吧",
    platformIcon: "ri-chat-1-line",
    user: "吧务小透明",
    time: "1天前",
    text: "集中楼里对线一晚上，其实两边都没什么实锤，多数是情绪输出。建议新来的先把考古帖看完再站队，不然容易被带节奏。",
    likes: "8600",
    replies: 189,
    sentiment: "neutral",
  },
  {
    id: 5,
    platform: "微博",
    platformIcon: "ri-weibo-line",
    user: "苏苏的小花园",
    time: "1天前",
    text: "十年老粉来说一句：喜欢过她真的不丢人，是后来的她变了。她教会我的，大概是不要把网线对面的人当偶像。脱粉但不回踩。",
    likes: "3.8万",
    replies: 754,
    sentiment: "negative",
  },
  {
    id: 6,
    platform: "抖音",
    platformIcon: "ri-voiceprint-line",
    user: "板栗炖鸡",
    time: "1天前",
    text: "评论区清一色群嘲，但我反而觉得，敢在风口浪尖上开直播回应的，多少还算有点担当。先不跟风，蹲个后续。",
    likes: "1.2万",
    replies: 203,
    sentiment: "positive",
  },
  {
    id: 7,
    platform: "小红书",
    platformIcon: "ri-pen-nib-line",
    user: "Mia_酱酱",
    time: "2天前",
    text: "最让我下头的是她推的那几款东西，买回来真的不行，评论区还不让说。赚钱可以，吃相别太难看。",
    likes: "2.6万",
    replies: 522,
    sentiment: "negative",
  },
  {
    id: 8,
    platform: "贴吧",
    platformIcon: "ri-chat-1-line",
    user: "观察员阿哲",
    time: "2天前",
    text: "其实这种翻车剧情每周都在上演，区别在于有人体面退场，有人硬刚到底。她选了一条最热闹也最危险的路，热度拉满，但代价是路人缘。",
    likes: "6800",
    replies: 96,
    sentiment: "neutral",
  },
  {
    id: 9,
    platform: "微博",
    platformIcon: "ri-weibo-line",
    user: "奶茶三分糖",
    time: "3天前",
    text: "全网都在笑她，可我想说：一个素人靠敢说敢做被看见，又因为太敢而翻车，这本身就很真实。至少她不装。",
    likes: "9700",
    replies: 128,
    sentiment: "positive",
  },
  {
    id: 10,
    platform: "抖音",
    platformIcon: "ri-voiceprint-line",
    user: "陈师傅说两句",
    time: "3天前",
    text: "逐帧看完了，所谓实锤更多是剪辑和断章取义。互联网吃瓜第一课：让子弹飞一会儿，别急着给任何人盖章。",
    likes: "5.4万",
    replies: 903,
    sentiment: "neutral",
  },
];